import React from "react";
import AppLayout from "../components/AppLayout";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Sun, Moon, Globe, LogOut, Link2 } from "lucide-react";
import ConnectedAccounts from "../components/ConnectedAccounts";

const Settings = () => {
    const { language, theme, updateSettings, logout, user } = useApp();

    return (
        <AppLayout title={t(language, "nav_settings")}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <Card className="rounded-2xl bg-[hsl(var(--card))] border-[hsl(var(--border))]">
                    <CardHeader>
                        <CardTitle className="font-display text-xl flex items-center gap-2"><Globe className="w-4 h-4" /> {t(language, "language")}</CardTitle>
                    </CardHeader>
                    <CardContent className="flex gap-3">
                        <Button data-testid="settings-lang-es" onClick={() => updateSettings({ language: "es" })} variant={language === "es" ? "default" : "outline"} className="pill">Español</Button>
                        <Button data-testid="settings-lang-en" onClick={() => updateSettings({ language: "en" })} variant={language === "en" ? "default" : "outline"} className="pill">English</Button>
                    </CardContent>
                </Card>

                <Card className="rounded-2xl bg-[hsl(var(--card))] border-[hsl(var(--border))]">
                    <CardHeader>
                        <CardTitle className="font-display text-xl flex items-center gap-2">
                            {theme === "dark" ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />} {t(language, "theme")}
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="flex gap-3">
                        <Button data-testid="settings-theme-light" onClick={() => updateSettings({ theme: "light" })} variant={theme === "light" ? "default" : "outline"} className="pill gap-2"><Sun className="w-4 h-4" />{t(language, "light")}</Button>
                        <Button data-testid="settings-theme-dark" onClick={() => updateSettings({ theme: "dark" })} variant={theme === "dark" ? "default" : "outline"} className="pill gap-2"><Moon className="w-4 h-4" />{t(language, "dark")}</Button>
                    </CardContent>
                </Card>

                <Card className="rounded-2xl bg-[hsl(var(--card))] border-[hsl(var(--border))] lg:col-span-2">
                    <CardHeader>
                        <CardTitle className="font-display text-xl flex items-center gap-2"><Link2 className="w-4 h-4" /> {t(language, "connect_bank")}</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ConnectedAccounts />
                    </CardContent>
                </Card>

                <Card className="rounded-2xl bg-[hsl(var(--card))] border-[hsl(var(--border))] lg:col-span-2">
                    <CardHeader>
                        <CardTitle className="font-display text-xl">{t(language, "settings_account")}</CardTitle>
                    </CardHeader>
                    <CardContent className="flex items-center justify-between">
                        <div className="text-sm">
                            <div className="font-medium">{user?.name}</div>
                            <div className="text-[hsl(var(--muted-foreground))]">{user?.email}</div>
                        </div>
                        <Button data-testid="settings-logout" onClick={logout} variant="outline" className="pill gap-2"><LogOut className="w-4 h-4" />{t(language, "logout")}</Button>
                    </CardContent>
                </Card>
            </div>
        </AppLayout>
    );
};

export default Settings;
